<template>
    <wrapper>
        <div class="loading center" v-if="loading">
            <pre-loader></pre-loader>
        </div>
        <div class="row " v-else>
            <div class="col m8 offset-m2">
                <div class="card ">
                    <div class="card-header center" style="padding-top:10px;margin-top:20px;">
                            <h5>Your Answer for {{ data[0].exam.subject.name }} Exam</h5>
                            <h6>Your Total Mark = {{ totalmark }}</h6>
                    </div>
                    <div class="card-content">
                          <div class="row" v-for="(item,index) in data">
                            <p>{{ index+1 }}. <span class="questions" v-html="item.question.question"></span></p>
                            <div class="row" style="margin-top:10px;margin-left:50px;">

                                <p>Your Answer : {{ item.option.option }}  
                                    <i v-if="item.option.answer==1" class="material-icons right green-text" style="margin-right:30%;">done</i>
                                    <i v-else class="material-icons right red-text" style="margin-right:30%;">highlight_off</i>
                                </p>
                                
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </wrapper>
</template>
<script>
export default {
    mounted() {
        this.$store.dispatch("get_exam_detail",{id:this.$route.params.id});
    },
     computed: {
        loading()
        {
            return this.$store.getters.exam_loading;
        },
        data()
        {
            return this.$store.getters.exams;
        },
        totalmark()
        {
            var mark=0;
            this.data.map((value)=>{
                if (value.option.answer==1) mark++;
            })
            return mark;
        }
       
    },
}
</script>
<style lang="scss">
    
</style>